import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { signIn } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const m = location.hash.match(/session_id=([^&]+)/);
    if (!m) return;
    api.post("/auth/session", { session_id: m[1] })
      .then((r) => {
        signIn(r.data);
        window.history.replaceState(null, "", "/");
        nav("/", { replace: true });
      })
      .catch((e) => setError(errMsg(e)));
  }, [location.hash, nav, signIn]);

  if (!error) return null;
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md rounded-2xl border bg-white p-6" role="alert" data-testid="auth-error">
        <h1 className="text-2xl font-semibold mb-2">Sign-in not allowed</h1>
        <p className="text-muted-foreground mb-4">{error}</p>
        <a href="/login" className="font-semibold text-[color:var(--dcbc-red)]">Back to sign in</a>
      </div>
    </div>
  );
}
